import { useAuth } from "../App";
import { Anchor } from "lucide-react";
import { EntryAnchorTab } from "../components/EntryAnchorTab";

export default function EntryAnchorPage() {
  const { token } = useAuth();
  return (
    <div className="min-h-screen bg-background p-4 md:p-6" data-testid="entry-anchor-page">
      <div className="max-w-7xl mx-auto space-y-6">
        <div>
          <h1 className="text-2xl font-bold flex items-center gap-2">
            <Anchor className="h-6 w-6 text-emerald-400" />
            Entry Anchoring
          </h1>
          <p className="text-muted-foreground text-sm mt-1">
            Expected forward alpha from the funds' estimated entry basis — V3 score model
          </p>
        </div>
        <EntryAnchorTab token={token} />
      </div>
    </div>
  );
}
